import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { Icon } from '../Icon/Icon';
import { getIconColor } from '../Icon/iconConst';
import { Rotator } from '../Rotator/Rotator';
const ICON_CLOSED_ROTATION_DEGREES = 90;
const ICON_OPENED_ROTATION_DEGREES = 270;
const HOVER_ICON_COLOR = getIconColor('action');
const StyledIconWrapper = styled('div', (p) => ({
    color: p.$wrapperColor,
    ...(p.$hasHover && { ':hover': { color: HOVER_ICON_COLOR } }),
}));
export const ButtonRotator = ({ open, iconColor, iconName = 'ChevronLeft', iconClosedRotationDegrees = ICON_CLOSED_ROTATION_DEGREES, iconOpenedRotationDegrees = ICON_OPENED_ROTATION_DEGREES, hasHover = false, }) => {
    const rotatedIconDegrees = open
        ? iconClosedRotationDegrees
        : iconOpenedRotationDegrees;
    const maybeIconColorOverride = hasHover ? 'currentColor' : undefined;
    const wrapperColor = getIconColor(iconColor);
    return (_jsx(StyledIconWrapper, { $wrapperColor: wrapperColor, $hasHover: hasHover, children: _jsx(Rotator, { rotationInDeg: rotatedIconDegrees, children: _jsx(Icon, { name: iconName, color: iconColor, colorOverride: maybeIconColorOverride }) }) }));
};
